import e from"./array-species-constructor.js";var t=e,o=function(a,r){return new(t(a))(r===0?0:r)};export{o as default};
